import React from 'react';
import PropTypes from 'prop-types';
import {Hidden} from '@material-ui/core';
import DataTable from '../../shared/components/list_view/DataTable';
import MobileEquipmentList from './MobileEquipmentList';
import Spinner from '../../shared/components/Spinner';

const EquipmentGrid = props => {
  const {loading, columns, records} = props;
  return (
    <React.Fragment>
      {loading && <Spinner />}
      <Hidden mdDown>
        <DataTable header={columns} rows={records} {...props} />
      </Hidden>
      <Hidden lgUp>
        <MobileEquipmentList rows={records} {...props} />
      </Hidden>
    </React.Fragment>
  );
};

EquipmentGrid.propTypes = {
  columns: PropTypes.array.isRequired,
  records: PropTypes.array.isRequired,
  hasNext: PropTypes.bool.isRequired,
  goToNextPage: PropTypes.func.isRequired
};

export default EquipmentGrid;
